export default __webpack_public_path__ + "092a1434dd95f3e2d97504a0b27730da.glb";